if(!customElements.get('accordion-content')) { 
  class AccordionContent extends HTMLElement {
    static observedAttributes = ["open"];

    constructor() {
      super();

      this.open = this.getAttribute('open') == 'true';

      this.elToggle = this.querySelector('[data-toggle]');
      this.elContent = this.querySelector('[data-content]');

      this.elToggle.addEventListener('click', this.toggleAccordion.bind(this));

      this.enabled = true;
      this.enabledDesktop = this.getAttribute('enabled-desktop') == 'true';

      if(!this.enabledDesktop) {
        const enableDisableDesktop = () => {
          let isDesktop = window.matchMedia('(min-width: 1024px)').matches;
          isDesktop ? this.disable() : this.enable();
        }

        setTimeout(() => enableDisableDesktop(), 500);
        window.addEventListener('resize', enableDisableDesktop);
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      newValue == "true" ? this.openAccordion() : this.closeAccordion();
    }

    openAccordion() {
      this.open = true;
      this.classList.add('visible');
      setTimeout(() => {
        this.classList.add('open');
        this.elToggle.setAttribute('aria-expanded', true);
        this.elContent.setAttribute('aria-hidden', false);
      }, 50);
    }

    closeAccordion() {
      this.open = false;
      this.classList.remove('open');
      this.elToggle.setAttribute('aria-expanded', false);
      this.elContent.setAttribute('aria-hidden', true);
      setTimeout(() => {
        this.classList.remove('visible');
      }, 300)
    }

    disable() {
      this.enabled = false;
      this.elToggle.disabled = true;
      this.setAttribute('open', true);
    }

    enable() {
      this.enabled = true;
      this.elToggle.disabled = false;
      this.setAttribute('open', false);
    }

    toggleAccordion() {
      this.setAttribute('open', !this.open);
    }
  }
  customElements.define('accordion-content', AccordionContent);
}